import React from 'react';
import defaultAvatarImage from '../assets/avatar.png';

const AvatarGroup = ({ avatarText, avatarImage }) => {
	return (
		<div className="flex items-center">
			<img src={avatarImage || defaultAvatarImage} alt="Professional avatars" className="h-[34px]" />
			<div className="ml-2 md:ml-4 text-gray-600">
				{avatarText ? (
					avatarText
				) : (
					<>
						<span className="font-semibold">4,500+</span> professionals boosted their salaries this month
					</>
				)}
			</div>
		</div>
	);
};

export default AvatarGroup;
